import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { TYPE_FAM, TYPE_LABEL, contactStatus } from '../../utils/contacts';
import { Chip, I } from '../Todos/ui';

export function Sec({ title, icon, right, children }) {
  return (
    <div className="cp-sec">
      <div className="cp-sh">
        <I icon={icon} />
        <span className="b">{title}</span>
        <div className="grow" />
        {right}
      </div>
      <div className="cp-sb">{children}</div>
    </div>
  );
}

export function Kv({ rows }) {
  return (
    <div className="cp-kv">
      {rows.filter(Boolean).flatMap(([k, v]) => [
        <span key={`${k}k`} className="m-sub">
          {k}
        </span>,
        <span key={`${k}v`} className="sm">
          {v}
        </span>
      ])}
    </div>
  );
}

export function Lrow({ icon, title, sub, right, onClick, clamp }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag type={onClick ? 'button' : undefined} className="cp-lrow" onClick={onClick}>
      <span className="m-bub sm">
        <I icon={icon} />
      </span>
      <div className="grow">
        <div className="sm b">{title}</div>
        {sub && <div className={clamp ? 'sm cp-clamp' : 'm-sub'}>{sub}</div>}
      </div>
      {right}
      {onClick && <I icon={faChevronRight} />}
    </Tag>
  );
}

export const Muted = ({ children }) => <div className="m-sub">{children}</div>;

export const TypeChip = ({ type }) => <Chip fam={TYPE_FAM[type] || 'neutral'}>{TYPE_LABEL[type] || type}</Chip>;

export function StatusChip({ contact }) {
  const [label, fam] = contactStatus(contact);
  return label ? <Chip fam={fam}>{label}</Chip> : null;
}
